var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHivioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 19,
    viewBox: "0 0 105 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3467 16.837V2.16748H34.3884V7.98922H43.8173V2.16748H47.859V16.837H43.8173V10.9472H34.3884V16.837H30.3467Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0205 16.837V2.16748H56.0622V16.837H52.0205Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5928 0H20.9431V3.17264H10.5928V0Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5928 6.32959H20.9431V9.50223H10.5928V6.32959Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5928 12.6748H20.9431V15.8474H10.5928V12.6748Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M63.9786 16.837L58.1621 2.16748H63.0362L68.4496 15.1826H68.7166L74.0515 2.16748H75.3708L69.1407 16.837H63.9838H63.9786Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1621 2.16748L63.9786 16.837H69.1407L63.0362 2.16748H58.1621Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4697 16.837V2.16748H81.5114V16.837H77.4697Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.25 9.50215C85.25 4.92644 88.9671 1.94751 94.9459 1.94751C100.925 1.94751 104.752 4.92644 104.752 9.50215C104.752 14.0779 101.061 17.0568 94.9459 17.0568C88.831 17.0568 85.25 14.0779 85.25 9.50215ZM100.443 9.50215C100.443 6.24052 98.9091 5.0992 94.9459 5.0992C90.9827 5.0992 89.5325 6.23528 89.5325 9.50215C89.5325 12.769 90.988 13.9051 94.9459 13.9051C98.9039 13.9051 100.443 12.769 100.443 9.50215Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57225 6.34527C7.43098 6.34527 5.91796 5.76415 4.36305 4.34536L4.26358 4.25112C3.36309 3.43441 2.59349 3.15693 1.25847 3.15693H0.248047V0H1.25324C3.41545 0 4.98082 0.602068 6.49385 2.02085L6.55144 2.07321C7.49904 2.9161 8.2477 3.18834 9.57225 3.18834H10.5931L10.5984 6.34004H9.59842C9.59842 6.34004 9.58272 6.34004 9.57225 6.34004V6.34527Z",
    fill: "#081231"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57225 12.6748C7.43098 12.6748 5.91796 12.0936 4.36305 10.6748L4.26358 10.5806C3.36833 9.76389 2.59349 9.48641 1.25847 9.48641H0.248047V6.33472H1.25324C3.41545 6.33472 4.98082 6.93678 6.49385 8.35557L6.55144 8.40792C7.49904 9.25082 8.2477 9.52306 9.57225 9.52306H10.5931L10.5984 12.6748H9.59842C9.59842 12.6748 9.58272 12.6748 9.57225 12.6748Z",
    fill: "#081231"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57225 19.0043C7.43098 19.0043 5.91796 18.4232 4.36305 17.0044L4.26358 16.9102C3.36309 16.0935 2.59349 15.816 1.25847 15.816H0.248047V12.6643H1.25324C3.41545 12.6643 4.98082 13.2664 6.49385 14.6852L6.55144 14.7375C7.49904 15.5804 8.2477 15.8526 9.57225 15.8526H10.5931L10.5984 19.0043H9.59842C9.59842 19.0043 9.58272 19.0043 9.57225 19.0043Z",
    fill: "#081231"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.503,
    height: 19.0044,
    fill: "white",
    transform: "translate(0.248047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHivioLogo);
export default __webpack_public_path__ + "static/media/hivio-logo.c0d087f6e36c12b6ad5ed510ee460ada.svg";
export { ForwardRef as ReactComponent };